import { render, staticRenderFns } from "./ObrigadoTarotYesNo.vue?vue&type=template&id=4fca4f72"
import script from "./ObrigadoTarotYesNo.vue?vue&type=script&lang=js"
export * from "./ObrigadoTarotYesNo.vue?vue&type=script&lang=js"
import style0 from "./ObrigadoTarotYesNo.vue?vue&type=style&index=0&id=4fca4f72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports